module.exports = __webpack_public_path__ + "static/mockups-83d977cdd0bfd4bcae97380ad1f30c43.png";